module.exports = __webpack_public_path__ + "4c7b765792534586aa41ebbaa8452b43.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/IM.svg
// module id = oVDZ
// module chunks = 0